exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons[data-v-dd20d6c2]{margin-top:35px}.ghost[data-v-dd20d6c2]{opacity:.5;background:#c8ebfb}", ""]);

// exports
